<template>
  <div id="receptionist" class="mb-2 wrrapper">
    <page-heading title="Patients Details Report" border></page-heading>
    <div class="header flex align-center justify-end mt-2">
      <Input
        @enter="handleSearch"
        v-model="searchText"
        type="text"
        placeholder="Mr_no / Mobile No"
        icon="mdi-magnify"
        class="mr-1"
        :handleSearch="handleSearch"
      />
      <div
        class="flex align-center mr-1 cursor"
        @click="printReport"
        v-if="histories.length"
      >
        <img src="@/assets/print-icon.png" alt="" />
      </div>
    </div>
    <div class="content">
      <div class="details flex space-between flex-wrap">
        <Input
          class="mb-base"
          label="Full Name"
          type="text"
          v-model="detailsPatient.name"
          disabled
        />
        <Input
          class="mb-base"
          label="Father/Husband Name"
          type="text"
          v-model="detailsPatient.fatherOrHusbandName"
          disabled
        />
        <Input
          class="mb-base"
          label="Address"
          type="text"
          v-model="detailsPatient.address"
          disabled
        />
        <Input
          class="mb-base"
          label="Contact Number"
          v-model="detailsPatient.contactNumber"
          type="text"
          disabled
        />
      </div>
      <data-table
        :cols="columns"
        :rows="histories || []"
        height="calc(100vh - 34.5rem)"
        :loading="loading"
      >
        <template slot="action" slot-scope="{ actions }">
          <dropdown-menu
            :rowData="actions"
            :handleItemClick="handleItems"
            :items="items"
          />
        </template>
      </data-table>
    </div>
    <PrintTable
      :searchResult="detailsPatient"
      :registerPatient="detailsPatient"
      :rows="histories"
      :total="total - discount"
      :discount="discount"
      :id="'print-details-report'"
      class="mb-base"
    />
  </div>
</template>

<script>
import DataTable from "@/components/DataTable";
import DropdownMenu from "@/components/DropdownMenu";
import PrintTable from "@/components/PrintTable";
import Input from "@/components/Input";
import printDiv from "@/utils/print";
import { mapActions, mapGetters } from "vuex";
import { downloadPdf } from "../../../utils/helpers";
import { permissionsMiddleWare } from "../../../utils/permissionsMiddleWare";
export default {
  components: {
    DropdownMenu,
    PrintTable,
    DataTable,
    Input
  },
  data() {
    return {
      searchText: "",
      isOther: "FHHL",
      items: ["Print"],
      columns: [
        { column: "serial", label: "#", width: "60" },
        {
          column: "created_at",
          label: "Created At",
          sortable: true
        },
        {
          column: "name",
          label: "Service Name",
          sortable: true
        },
        {
          column: "price",
          label: "Price",
          sortable: true
        },
        {
          column: "quantityNumber",
          label: "quantity",
          sortable: true
        },
        {
          column: "discountValue",
          label: "discount",
          sortable: true
        },
        {
          column: "subtotal",
          label: "Total",
          sortable: true
        }
      ]
    };
  },
  methods: {
    ...mapActions("receptionist", ["searchHistory", "patientDetails"]),
    handleSearch() {
      if (permissionsMiddleWare("History By Mr")) {
        const data = {
          searchText: this.searchText,
          branchId: this.userInfo?.userBranchId
        };

        this.searchHistory(data).then(() => {
          this.patientId
            ? this.patientDetails(this.patientId)
            : this.$toasted.success("No history found").goAway("3000");
        });
      } else {
        this.$toasted
          .info(
            "This action cannot be performed by you due to insufficient authorization. Action: History By Mr"
          )
          .goAway("3000");
      }
    },
    handleItems(val, rowData) {
      if (val == "Print") {
        downloadPdf(rowData.path);
        rowData.path == null
          ? this.$toasted.show("No report available").goAway("3000")
          : "";
      }
    },
    printReport() {
      const details = {
        mrNo: this?.detailsPatient?.mr_no
      };
      printDiv("print-details-report", details);
    }
  },
  computed: {
    ...mapGetters({
      historySearchResults: "receptionist/historySearchResults",
      detailsPatient: "receptionist/detailsPatient",
      loading: "loading",
      userInfo: "auth/userInfo"
    }),
    history() {
      return (
        this?.detailsPatient?.histories?.filter(history => history.charge) || []
      );
    },
    histories() {
      return this.history.map(item => ({
        status: item.status,
        name: item?.charge?.service?.name,
        price: item?.charge?.amount,
        discountValue: item?.discount,
        quantityNumber: item?.quantity,
        subtotal: item?.charge?.amount - item?.discount,
        invoice: item?.invoice_no,
        created_at: item?.created_at
      }));
    },
    discount() {
      return this.history?.reduce((acc, item) => acc + item?.discount, 0);
    },
    total() {
      return this.history?.reduce((acc, item) => acc + item?.charge?.amount, 0);
    },
    patientId() {
      const searchResults = this.historySearchResults || [];
      const [newArr] = [...searchResults];
      return newArr.patientId;
    }
  }
};
</script>

<style>
.content .details {
  padding: 20px 14px;
}
.content .details > div {
  flex: 0 0 30%;
  max-width: 30%;
}
#receptionist .actions .edit {
  color: var(--accent-600) !important;
}
.patient-search {
  border: 1px solid var(--line);
  border-radius: var(--radius-sm);
}
#receptionist .patient-search input {
  padding: 9px 0 9px 15px;
  border: none;
  margin: 0;
  width: 200px;
}
#receptionist .footer {
  margin-right: 30px;
}
.patient-search .customInput {
  margin-bottom: 0;
}
#receptionist .patient-search span {
  color: var(--muted);
  background: var(--surface-2);
  border-left: 1px solid var(--line-strong);
  padding: 11px 15px 7px 15px;
}
#receptionist .content .table {
  border-left: none;
  border-right: none;
  border-bottom: none;
}
.add-template {
  padding: 10px 15px;
}
.template-title {
  width: 300px;
}
</style>
